
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Urbaniaonrentinpuneforcorporate() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Pune for Corporate',
        heading: 'etravo :  Urbania On Rent in Pune for Corporate',
        headingDescription: 'eTravo offers Urbania on Rent in Pune for Corporate travel, delivering a premium, efficient, and comfortable transport solution for business professionals. Ideal for small teams, client visits, airport transfers, and intercity travel, our Urbania vans feature plush seating, air conditioning, ample luggage space, and real-time GPS tracking. With courteous chauffeurs and flexible rental packages, we ensure that your corporate travel is punctual, safe, and hassle-free. Whether it is for daily commutes or special events, eTravo’s Urbania rental service is trusted by top companies across Pune’s business hubs.',

        top: 'Top Places to Visit in Pune with etravo',
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a majestic 18th-century fortification located in the heart of Pune. Built in 1732 by the Peshwas of the Maratha Empire, it served as their seat of power until 1818. The grand entrance, known as the Delhi Darwaza, and the intricate architecture reflect the glory of Maratha rule. Although much of the fort was destroyed in a fire in 1828, its remaining walls, gardens, and fountains still echo the stories of royal intrigue, valor, and politics. It is a must-visit for history enthusiasts and those curious about Pune’s regal heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace is not just a stunning piece of architecture but also a monument of national significance. Built in 1892 by Sultan Aga Khan III, the palace is closely associated with India’s freedom movement. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. With its Italian arches, sprawling gardens, and a museum housing Gandhiji’s memorabilia, the palace provides a serene yet powerful reminder of India’s struggle for independence. It’s a place of reflection, peace, and inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, meaning 'Lion's Fort', is perched atop a rugged hill about 35 km from Pune. A site of many historical battles, it is most famous for the Battle of Sinhagad in 1670, where the Maratha warrior Tanaji Malusare fought valiantly. The fort offers panoramic views of the surrounding Sahyadri mountains and the Khadakwasla dam. A favorite among trekkers and nature lovers, the fort also features remnants of ancient gates, temples, military stables, and even food stalls offering local snacks like kanda bhaji and pithla-bhakri."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple is a hidden gem amidst Pune’s urban sprawl. Carved out of a single basalt rock in the 8th century, this ancient temple is dedicated to Lord Shiva and features beautifully sculpted pillars and a Nandi bull in the courtyard. Despite being in the middle of the bustling Jangli Maharaj Road, the temple offers a peaceful, almost timeless ambiance. Its unfinished structure adds to its mystique, making it a fascinating stop for lovers of history, architecture, and spirituality."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum is a treasure trove of India's rich cultural legacy. Founded by Dr. Dinkar G. Kelkar in memory of his son, the museum houses over 20,000 artifacts that span centuries. From musical instruments and antique furniture to intricate ivory carvings and everyday tools, each item tells a story of India’s diverse traditions and artistry. A full-scale replica of a traditional Maratha wada (mansion) is one of the highlights. Located in central Pune, this museum offers a deep dive into India’s folk and decorative arts."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "One of Pune’s most beloved and iconic spiritual sites, the Dagdusheth Halwai Ganapati Temple attracts thousands of devotees every day. The temple is known for its magnificent Ganesh idol, adorned with gold and fresh flowers, and its vibrant atmosphere during Ganesh Chaturthi. Built over 130 years ago by a sweet merchant named Dagdusheth Halwai, the temple is not only a center of faith but also a hub for community activities, charity, and cultural events. Its grandeur and spiritual aura make it a must-visit."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in the serene Koregaon Park area, the Osho Ashram is a global meditation hub that attracts spiritual seekers from across the world. Founded by the Indian mystic Osho, the resort offers a range of meditation techniques, wellness therapies, and personal growth workshops amidst tranquil Zen-like gardens and modern infrastructure. Visitors can enroll for day passes or longer retreats and enjoy a unique blend of spirituality, luxury, and self-discovery in one of India’s most sophisticated wellness centers."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Inspired by the Korakuen Garden of Okayama, Japan, this beautifully landscaped park, also known as the Pu La Deshpande Udyan, is a symbol of Indo-Japanese friendship. Spread across 10 acres, it features manicured lawns, flowing streams, wooden bridges, and bonsai-style trees. The garden offers a peaceful environment for walking, photography, or quiet contemplation, making it one of the most scenic urban escapes in Pune."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of the oldest heritage landmarks in Pune, rising 2,100 feet above sea level. A climb of 103 steps leads you to a group of five temples, the main one dedicated to Goddess Parvati. From the top, visitors are treated to a panoramic view of the entire city. The hill also houses a small museum and the Peshwa-era samadhis (memorials), making it a spiritual and historical site worth visiting—especially during sunrise or sunset."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Situated about 20 km from Pune, Khadakwasla Dam is a peaceful retreat that provides drinking water to the city. Surrounded by hills and greenery, it’s a favorite weekend getaway for picnics, morning walks, and watching the sunset over the backwaters. The area is also popular with cyclists and joggers. On weekends, local food stalls set up shop, offering mouthwatering Maharashtrian snacks, making it a blend of natural beauty and local flavor."
  }
],

"services": [
  {
    "name": "Corporate Urbania Hire in Pune",
    "description": "eTravo provides Corporate Urbania hire in Pune, offering businesses a spacious and reliable travel option for employee transport, team travel, and executive movement. Our Urbania vans are known for their comfort, safety features, and suitability for city and outstation routes alike."
  },
  {
    "name": "AC Urbania for Office Commute Pune",
    "description": "Upgrade your daily office commute with eTravo’s AC Urbania vans in Pune. Perfect for mid-sized teams, these air-conditioned vehicles offer a smooth and comfortable ride, ideal for companies looking to ensure quality daily transport for their employees across the city."
  },
  {
    "name": "Urbania Vans for Employee Transport Pune",
    "description": "eTravo offers Urbania vans for efficient and cost-effective employee transport in Pune. With ample seating, air-conditioning, and experienced drivers, these vans are perfect for regular shift operations, helping reduce absenteeism and increase employee satisfaction."
  },
  {
    "name": "Urbania for Business Meetings Pune",
    "description": "Ensure timely and professional travel for business meetings with eTravo’s Urbania rental services in Pune. These vans are ideal for transporting small groups of executives or clients, offering comfort, privacy, and a corporate travel experience tailored for productivity on the go."
  },
  {
    "name": "Comfortable Urbania Rental for Companies Pune",
    "description": "Choose eTravo’s comfortable Urbania rental services in Pune for a blend of space, style, and performance. Designed for corporate needs, our Urbania vans are great for staff transportation, team outings, or VIP movement with added flexibility and affordability."
  },
  {
    "name": "Staff Travel in Urbania Pune",
    "description": "Make staff transport seamless with eTravo’s Urbania services in Pune. Whether it’s daily commutes, interoffice transfers, or event transport, our well-maintained Urbania vans ensure comfort and punctuality while maintaining high service standards."
  },
  {
    "name": "Urbania Shuttle Service Pune",
    "description": "eTravo provides dedicated Urbania shuttle services in Pune for corporate campuses, industrial zones, and business parks. Our scheduled shuttles operate with fixed timings, GPS-enabled tracking, and clean, comfortable interiors to optimize daily commutes for staff and visitors alike."
  }
],
"tableData": [
  ["Corporate Urbania Hire in Pune", "AC Urbania for Office Commute Pune"],
  ["Urbania Vans for Employee Transport Pune", "Urbania for Business Meetings Pune"],
  ["Comfortable Urbania Rental for Companies Pune", "Staff Travel in Urbania Pune"],
  ["Urbania Shuttle Service Pune", ""]
],




"whychoose": [
    {
        "WhyChooseheading": "Urbania Vans on Rent in Pune for Corporate Travel",
        "WhyChoosedescription": "eTravo offers comfortable and spacious Urbania vans on rent in Pune, ideal for corporate groups, team shuttles, and executive travel. Whether it's daily office commutes or event-specific transport, our Urbania fleet ensures safe, reliable, and premium travel experiences."
    },
    {
        "WhyChooseheading": "Modern, Air-Conditioned Urbania Fleet",
        "WhyChoosedescription": "Our Urbania vans come with advanced features including powerful air-conditioning, plush reclining seats, clean interiors, and ample legroom—designed to provide a smooth and relaxing ride for professionals on the go."
    },
    {
        "WhyChooseheading": "Perfect for Mid-Sized Corporate Groups",
        "WhyChoosedescription": "With seating capacities ranging from 13 to 17 passengers, Urbania vans are perfect for transporting mid-sized corporate teams. Whether for client visits, group airport transfers, or corporate events, it’s the ideal blend of space and comfort."
    },
    {
        "WhyChooseheading": "Trained Drivers with Corporate Etiquette",
        "WhyChoosedescription": "Our experienced chauffeurs are trained to cater to corporate clients. They maintain punctuality, dress professionally, and are well-versed with Pune's key business zones like Hinjewadi, Baner, and Magarpatta, ensuring timely and smooth travel."
    },
    {
        "WhyChooseheading": "Timely Pickups with GPS-Enabled Tracking",
        "WhyChoosedescription": "Punctuality is critical in corporate travel. Our Urbania rentals include real-time GPS tracking and alert systems, so companies can monitor arrivals, delays, and routes with complete transparency and control."
    },
    {
        "WhyChooseheading": "GST Billing and Corporate-Friendly Pricing",
        "WhyChoosedescription": "We offer transparent pricing and GST-compliant invoices for easy reimbursement and expense management. Whether you're booking a one-time trip or setting up a recurring service, our billing system supports corporate needs efficiently."
    },
    {
        "WhyChooseheading": "Available 24/7 for Flexible Business Schedules",
        "WhyChoosedescription": "Whether your team needs to travel early in the morning or late at night, our Urbania vans are available around the clock. Our operations team is always on hand to manage bookings, changes, or urgent travel needs."
    },
    {
        "WhyChooseheading": "Book Easily via App, Web, or Support Line",
        "WhyChoosedescription": "With eTravo, booking an Urbania van in Pune is simple and quick. Use our mobile app, website, or speak directly with our support team. We provide instant confirmations, driver details, and complete travel visibility from start to finish."
    }
]





























    }

const faqData = [
    [
        {
            question: 'Does eTravo provide Urbania vans on rent for corporate use in Pune?',
            answer: 'Yes, eTravo offers Force Urbania vans on rent in Pune, tailored for corporate transportation needs such as employee transfers, business tours, client visits, and airport pickups.',
        },
        {
            question: 'What is the seating capacity of Urbania vans available for rent?',
            answer: 'Our Force Urbania vans typically accommodate 10 to 17 passengers, offering spacious interiors, reclining seats, and a smooth ride — perfect for executive-level group travel.',
        },
        {
            question: 'Are Urbania vans suitable for long-distance business travel from Pune?',
            answer: 'Absolutely. Urbania vans are well-suited for intercity travel from Pune to locations like Mumbai, Nashik, or corporate retreats in nearby hill stations, ensuring both comfort and reliability.',
        },
        {
            question: 'What amenities are included in eTravo’s Urbania rentals?',
            answer: 'Our Urbania vans come with air-conditioning, pushback seats, USB charging ports, reading lights, and experienced chauffeurs. Optional add-ons include Wi-Fi and refreshments.',
        },
        {
            question: 'Can we book Urbania vans for VIP guest or executive movement in Pune?',
            answer: 'Yes, many corporate clients choose Urbania vans for transporting VIP guests, senior management, or international clients thanks to the premium interiors and professional service.',
        },
        {
            question: 'Is real-time tracking available with Urbania van rentals?',
            answer: 'Yes, all Urbania vehicles are GPS-enabled and can be tracked in real-time through our client dashboard, ensuring full transparency and safety during transit.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Amit Tiwari',
        designation: 'Admin Executive, Nexon Technologies',
        rating: [1, 1, 1, 1, 1],
        text: '“We rented Urbania vans from eTravo for a corporate workshop in Lonavala. The service was impeccable — comfortable rides, timely pickups, and well-trained drivers.”',
    },
    {
        name: 'Ms. Richa Verma',
        designation: 'Corporate Travel Manager, FinTrust Corp',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s Urbania rentals are our go-to solution for team outings and VIP travel. The vehicles are in great condition and the service is always reliable.”',
    },
];



















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Pune for Corporate",
  "image": "https://www.etravo.in/images/keyword/urbania-rent-corporate-pune.jpg",
  "description": "Reliable Urbania van rentals in Pune for corporate needs by eTravo. Ideal for employee transport, office commute, business meetings, and staff shuttle services with AC comfort and professional service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/urbania-on-rent-in-pune-for-corporate"
  }
};






    return (
        <div>

<Helmet>
  <title>Urbania On Rent in Pune for Corporate | eTravo</title>
  <meta 
    name="description" 
    content="Hire Urbania On Rent in Pune for Corporate transport with eTravo. AC Urbania for staff travel, office commute, and business meetings. Comfortable and professional rental service for companies in Pune."
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/27.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Urbaniaonrentinpuneforcorporate;